import { createFrontendModule } from '@backstage/frontend-plugin-api'
import { catalogGraphRouteRef } from '@backstage/plugin-catalog-graph'
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha'
import { RiNodeTree } from '@remixicon/react'

const GRAPH_KINDS = ['domain', 'system', 'component', 'api', 'resource']

// Same extensions as the catalog-graph plugin, rendered with brand-coloured nodes
// (kind colour, type, tier and environments on the node). Config still comes from app.extensions.
const relationsCard = catalogGraphPlugin
  .getExtension('entity-card:catalog-graph/relations')
  .override({
    factory(originalFactory, { config }) {
      return originalFactory({
        params: define =>
          define({
            type: config.type ?? 'content',
            loader: async () => {
              const [{ EntityCatalogGraphCard }, { DgGraphNode }] =
                await Promise.all([
                  import('@backstage/plugin-catalog-graph'),
                  import('./DgGraphNode'),
                ])
              return (
                <EntityCatalogGraphCard
                  renderNode={DgGraphNode}
                  title={config.title ?? 'Relations'}
                  height={config.height ?? 360}
                  kinds={config.kinds ?? GRAPH_KINDS}
                  relations={config.relations}
                  maxDepth={config.maxDepth ?? 1}
                  unidirectional={config.unidirectional}
                  mergeRelations={config.mergeRelations ?? true}
                  direction={config.direction ?? 'LR'}
                  zoom={config.zoom ?? 'enable-on-click'}
                  curve={config.curve}
                />
              )
            },
          }),
      })
    },
  })

const graphPage = catalogGraphPlugin
  .getExtension('page:catalog-graph')
  .override({
    factory(originalFactory, { config }) {
      return originalFactory({
        params: define =>
          define({
            path: config.path ?? '/catalog-graph',
            title: config.title ?? 'Catalog Graph',
            icon: <RiNodeTree size="1em" />,
            routeRef: catalogGraphRouteRef,
            loader: async () => {
              const [{ CatalogGraphPage }, { DgGraphNode }] = await Promise.all(
                [
                  import('@backstage/plugin-catalog-graph'),
                  import('./DgGraphNode'),
                ],
              )
              return (
                <CatalogGraphPage
                  renderNode={DgGraphNode}
                  initialState={{
                    rootEntityRefs: config.rootEntityRefs,
                    selectedKinds: config.selectedKinds ?? GRAPH_KINDS,
                    selectedRelations: config.selectedRelations,
                    maxDepth: config.maxDepth,
                    unidirectional: config.unidirectional,
                    mergeRelations: config.mergeRelations ?? true,
                    direction: config.direction ?? 'LR',
                    showFilters: config.showFilters,
                    curve: config.curve,
                  }}
                />
              )
            },
          }),
      })
    },
  })

export const graphModule = createFrontendModule({
  pluginId: 'catalog-graph',
  extensions: [relationsCard, graphPage],
})
